<template>
  <section class="country-detail-header">
    <div class="container-fluid px-0">
      <div class="header-hero">
        <img v-if="country_details.country_image" :src="country_details.country_image" width="100%"  :alt="meta.alt"/>
        <img v-else src="@/assets/imgs/uni-img.png" width="100%" style="filter: brightness(0.5) blur(2px);" :alt="meta.alt"/>
        


        <div class="header-overlay">
          <div class="header-main-title">
            <h1 v-if="country_details" >
              <!-- Study in <b>{{ country_details.country_name }}</b> -->
               {{ meta.metaTitle }}
            </h1>
          </div>
        </div>
      </div>

      <div class="header-hero" >
        <!-- v-if="country_details.country_image" -->
        <div class="image-overlay">

        </div>
        <!-- <img
          v-else
          src="@/assets/imgs/uni-img.png"
          width="100%"
          style="filter: brightness(0.5) blur(2px);"
        /> -->

      </div>

      <!-- <div class="px-4 detail-box-shadow py-4">
        <ul class="header-list py-0 m-0">
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#about">Ranking</a>
          </li>
          <li>
            <a href="#about">Admission</a>
          </li>
          <li>
            <a href="#about">Financials</a>
          </li>
          <li>
            <a href="#about">Programmes</a>
          </li>
          <li>
            <a href="#about">Blog</a>
          </li>
        </ul>
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "CountryDetailsHeader",
  props: {
    country_details: {
      type: Object,
      default: () => { }
    },
    meta: {
      type: Object,
      default: () => { }
    },
  }

};
</script>

<style>
.header-hero {
  position: relative;
}

.header-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
}

.header-main-title {
  color: white;
}

.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Country/Navigation.vue